<nav class="navbar navbar-expand-lg navbar-light"><div>
  <img src="assets/logodark.png" class="logo">
</div>
  <button class="navbar-toggler ml-auto hidden-sm-up float-xs-right" type="button" (click)="isMenuCollapsed = !isMenuCollapsed">
    &#9776;
  </button>
  <div [ngbCollapse]="isMenuCollapsed" class="collapse navbar-collapse ">
    <div class="navbar-nav ml-auto hidden-sm-up float-xs-right">
      <div ngbDropdown class="d-inline-block">
        <button class="btn btn-outline-primary" id="dropdownBasic1" ngbDropdownToggle>Nutzerverwaltung</button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
          <a (click)="tryChangeMail()" class="nav-link menuitem" [routerLink]="'.'" (click)="isMenuCollapsed = true">E-Mail ändern</a>
          <a (click)="tryReset()" class="nav-link menuitem" [routerLink]="'.'" (click)="isMenuCollapsed = true">Passwort ändern</a>
          <a (click)="logout()" class="nav-link menuitem" [routerLink]="'.'" (click)="isMenuCollapsed = true">Logout</a>
        </div>
      </div>

    </div>
  </div>
</nav>


